import { useSelector } from "react-redux";
import {
  getBlockSelectModels,
  selectBlockSelectModels,
  selectLastUpdateTime,
  selectLoading,
} from "./components/BlockSelectSlice";
import { useThunkDispatch } from "setup/redux/thunkDispatch";
import useCaching, { CachingOptions } from "cpl-react-common/Hooks/useCaching";
import MultiSelectDropdown from "cpl-react-common/components/Inputs/MultiSelectDropdown";
import { ActivityIndicator } from "cpl-react-common/components/ActivityIndicators/ActivityIndicator";
import { useCallback, useEffect } from "react";

type BlockSelectProps = {
  "data-test-id"?: string;
  handleChange: (selections: string[]) => void;
  defaultAll: boolean;
  defaultSome?: string[];
  disabled?: boolean;
  developmentIDs?: string[];
};

const EXPIRY_PERIOD_MS = 1000 * 60 * 30; // 30 minutes

const BlockSelectMulti: React.FC<BlockSelectProps> = (props) => {
  const loading = useSelector(selectLoading);
  const blockSelectModels = useSelector(selectBlockSelectModels);
  const lastUpdateTime = useSelector(selectLastUpdateTime);
  const thunkDispatch = useThunkDispatch();

  const updateSelectModels = useCallback(() => {
    thunkDispatch(getBlockSelectModels(props.developmentIDs));
  }, [props.developmentIDs, thunkDispatch]);

  const cachingOptions: CachingOptions = {
    lastUpdateTime,
    expiryPeriodMs: EXPIRY_PERIOD_MS,
    updateData: updateSelectModels,
    shouldUpdateOnLoad: blockSelectModels.length === 0,
  };

  useCaching(cachingOptions);

  useEffect(() => {
    updateSelectModels();
  }, [props.developmentIDs, updateSelectModels]);

  return (
    <ActivityIndicator isBusy={loading}>
      <MultiSelectDropdown
        data-test-id={props["data-test-id"]}
        handleChange={(selections) => props.handleChange(selections as string[])}
        options={blockSelectModels.map((x) => ({
          value: x.value!,
          label: x.label ?? "",
        }))}
        defaultAll={props.defaultAll}
        defaultSome={props.defaultSome}
        searchable={true}
        disabled={props.disabled}
      ></MultiSelectDropdown>
    </ActivityIndicator>
  );
};

export default BlockSelectMulti;
